import * as Icons from './../icons/AllIconsSvg';

export const skills = {
    CSS: <Icons.CssIcon />,
    HTML: <Icons.HTMLIcon />,
    Javascript: <Icons.JavaScriptIcon />,
    TypeScript: <Icons.TypescriptIcon />,
    'Next.js': <Icons.NextJsIcon />,
    React: <Icons.ReactIcon />,
    'React Native': <Icons.ReactIcon />,
    Redux: <Icons.ReduxIcon />,
    Figma: <Icons.FigmaIcon />,
    'Material UI': <Icons.MaterialUiIcon />,
    NestJS: <Icons.NestJsIcon />,
    NodeJS: <Icons.NodeJsIcon />,
    MySQL: <Icons.MysqlIcon />,
    PostgreSQL: <Icons.PostgresqlIcon />,
    Java: <Icons.JavaIcon />,
    'Android Studio': <Icons.AndroidStudioIcon />,
    Argo: <Icons.ArgoIcon />,
    Dart: <Icons.DartIcon />,
    Docker: <Icons.DockerIcon />,
    ESLint: <Icons.EsLintIcon />,
    Git: <Icons.GitIcon />,
    Jest: <Icons.JestIcon />,
    Jira: <Icons.JiraIcon />,
    Kubernetes: <Icons.KubernetesIcon />,
    Linux: <Icons.LinuxIcon />,
    Postman: <Icons.PostmanIcon />,
    Rancher: <Icons.RancherIcon />,
    Slack: <Icons.SlackIcon />,
    VSCode: <Icons.VsCodeIcon />,
    Expo: <Icons.ExpoIcon />,
};
